import React from 'react';
import { Play } from 'lucide-react';

interface VideoThumbnailProps {
  src: string;
  className?: string;
  showPlayButton?: boolean;
  onClick?: (e?: React.MouseEvent) => void;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ 
  src, 
  className = '', 
  showPlayButton = false,
  onClick
}) => {
  return (
    <div 
      className={`relative bg-gray-900 ${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={(e) => onClick?.(e)}
    >
      {/* Video element with poster frame */}
      <video
        src={src}
        className="w-full h-full object-cover"
        preload="metadata"
        muted
        playsInline
        onError={(e) => {
          const target = e.target as HTMLVideoElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent) {
            parent.innerHTML = '<div class="w-full h-full flex items-center justify-center text-white bg-gray-800"><svg class="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></div>';
          }
        }}
      />
      
      {/* Play button overlay */}
      {showPlayButton && (
        <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity pointer-events-none">
          <div className="w-12 h-12 bg-black/60 backdrop-blur-sm rounded-full flex items-center justify-center">
            <Play className="w-6 h-6 text-white ml-1" />
          </div>
        </div>
      )}
      
      {/* Video type badge */}
      <div className="absolute top-2 left-2 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded flex items-center gap-1">
        <Play className="w-3 h-3" />
        VIDEO
      </div>
    </div>
  );
};

export default VideoThumbnail;
export { VideoThumbnail };